<div class="bg-slate-200  min-h-screen">


<div class="mx-auto lg:ml-80 lg:mr-8 pb-4">

  <div class="p-5 rounded-tl-md rounded-tr-md bg-white border-b border-slate-300">
    <h3
      class="text-base md:text-lg font-medium text-left rtl:text-right text-gray-900  dark:text-white dark:bg-gray-800">
      API / Backend Logs </h3>
    <!-- <p class="mt-1 text-sm font-normal text-gray-500 dark:text-gray-400">
        Browse a list of Flowbite products designed to help you work and play, stay organized, get answers, keep in touch,
        grow your business, and more.
      </p> -->
  </div>

  <!-- <div class="text-center mt-8 mb-8" *ngIf="spinner">
      <div role="status">
        <svg aria-hidden="true" class="inline w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-orange-600"
          viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor" />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill" />
        </svg>
        <span class="sr-only">Loading...</span>
      </div>
    </div> -->



  <ng-container>


    <div class="w-full bg-white text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">

      <div class="p-5 flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between pb-4">

        <div class="">
          <app-dropdown-radio [options]="filterOptions"
            (optionSelected)="onOptionSelected($event)"></app-dropdown-radio>
        </div>

        <label for="table-search" class="sr-only">Search</label>
        <div class="relative">
          <div class="absolute inset-y-0 left-0 rtl:inset-r-0 rtl:right-0 flex items-center ps-3 pointer-events-none">
            <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor"
              viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                clip-rule="evenodd"></path>
            </svg>
          </div>
          <input type="text" id="table-search" (keyup)="handleSearch($event)"
            class="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-full md:w-80 bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            placeholder="Search for items">
        </div>
      </div>

      <!-- <ng-container *ngIf="logsData.length ==0 && !spinner">
          <div class="flex justify-center pb-8 pt-8">
            <img src="/assets/images/no-data.svg" style="height: 40vh;" alt="">
          </div>
          <div class="flex justify-center pb-8 font-bold">
            <p>No Data found</p>
          </div>
        </ng-container> -->

      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" class="px-3 md:px-6 py-3">
                S.no
              </th>
              <th scope="col" class="px-3 md:px-6 py-3">
                Request User Agent
              </th>
              <th scope="col" class="px-3 md:px-6 py-3">
                Request Host
              </th>
              <th scope="col" class="px-3 md:px-6 py-3">
                Request Url
              </th>
              <th scope="col" class="px-3 md:px-6 py-3">
                Request Method
              </th>
              <th scope="col" class="px-3 md:px-6 py-3">
                Status Code
              </th>
              <th scope="col" class="px-3 md:px-6 py-3">
                Status Message
              </th>
              <th scope="col" class="px-3 md:px-6 py-3">
                Requested At
              </th>
              <th scope="col" class="px-3 md:px-6 py-3">
                request IP
              </th>
              <th scope="col" class="px-3 md:px-6 py-3">
                Process Time
              </th>
              <th scope="col" class="px-3 md:px-6 py-3">
                Response Message
              </th>
              <th scope="col" class="px-3 md:px-6 py-3">
                View
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="pointer bg-white border-b hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700"
              *ngFor="let data of logsData;let i = index;">
              <td scope="row" class="px-3 md:px-6 py-4">
                {{startingIndex+i}}
              </td>
              <td scope="row" class="px-3 md:px-6 py-4">
                {{ data.request_user_agent.slice(0, 5) }}...{{ data.request_user_agent.slice(-5) }}
                <!-- {{data.request_user_agent}} -->
                <!-- data.meta.page | stringSlice : data.meta.page -->
              </td>
              <td class="px-3 md:px-6 py-4">
                {{data.request_host}}
              </td>
              <td class="px-3 md:px-6 py-4">
                {{data.request_url}}
              </td>
              <td class="px-3 md:px-6 py-4">
                {{ data.request_method}}
              </td>

              <td class="px-3 md:px-6 py-4">
                {{ data.status_code}}
              </td>

              <td class="px-3 md:px-6 py-4">
                {{ data.status_message}}
              </td>
              <td class="px-3 md:px-6 py-4">
                {{ data.requested_at}}
              </td>
              <td class="px-3 md:px-6 py-4">
                {{ data.request_ip}}
              </td>
              <td class="px-3 md:px-6 py-4">
                {{data.process_time ?? '--'}}
              </td>
              <td class="px-3 md:px-6 py-4">
                {{ data.response_message}}
              </td>

              <td class="px-3 md:px-6 py-4">
                <a class="pointer text-primary-600 dark:text-primary-500 hover:underline font-medium"
                  (click)="openModal(data)">View</a>
              </td>
            </tr>
            <tr *ngIf="logsData &&logsData.length ===0">
              <td colspan="12">
                <div class="flex justify-center pb-8 pt-8">
                  <img src="/assets/images/no-data.svg" style="height: 40vh;" alt="">
                </div>
                <div class="flex justify-center pb-8">
                  <p>No Data found</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="mt-4 mb-2">
          <app-pagination *ngIf="logsData && logsData.length > 0" [search]="searchQuery" [totalPages]="totalPages"
            (advertisingList)="list($event)" [apiUrl]="apiUrl" [currentPage]="currentPage" [limit]="itemsPerPage"
            (pageChanged)="onPageChange($event)" [totalItems]="totalItems" [firstIndex]="startingIndex"
            (startingIndex)="setStartingIndex($event)">
          </app-pagination>
        </div>
      </div>

      <app-modal [isOpen]="isModalOpen" [title]="'Error informations'" (onClose)="closeModal()">
        <div class="overflow-x-auto">
          <table class="w-full  common my-3">
            <tbody>
              <tr class="bg-white dark:bg-gray-800">
                <td class="px-3 md:px-6 py-4 text-black font-medium">Request url</td>
                <td class="px-3 md:px-6 py-4">{{ selectedLog?.request_url }}</td>
              </tr>
              <tr class="bg-white dark:bg-gray-800">
                <td class="px-3 md:px-6 py-4 text-black font-medium">Error message</td>
                <td class="px-3 md:px-6 py-4">{{ selectedLog?.response_message }}</td>
              </tr>
              <tr class="bg-white dark:bg-gray-800">
                <td class="px-3 md:px-6 py-4 text-black font-medium">Name</td>
                <td class="px-3 md:px-6 py-4">{{ selectedLog?.project_id?.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </app-modal>
    </div>
  </ng-container>
</div>
</div>